import { render } from "./Tickets.vue?vue&type=template&id=6445dae3&scoped=true"
import script from "./Tickets.vue?vue&type=script&lang=js"
export * from "./Tickets.vue?vue&type=script&lang=js"

import "./Tickets.vue?vue&type=style&index=0&id=6445dae3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6445dae3"

export default script